import { type Components, type Theme } from "@mui/material/styles";

import { type BadgeSize } from "../../components/Badge";

declare module "@mui/material/Badge" {
  interface BadgeOwnProps {
    size?: BadgeSize;
  }
}

export const muiBadgeOverrides: Components<Theme> = {
  MuiBadge: {
    defaultProps: {
      size: "medium",
    },
    styleOverrides: {
      badge: ({ theme }) => ({
        borderWidth: theme.borderWidth?.thick,
        borderStyle: "solid",
        color: theme.palette.error.contrastText,
        borderColor: theme.palette.base?.base,
        backgroundColor: theme.palette.error.main,
        boxSizing: "content-box",
        fontWeight: 600,
        variants: [
          {
            props: { size: "small" },
            style: {
              minWidth: "1rem",
              height: "1rem",
              padding: "0 4px",
              fontSize: "0.625rem",
            },
          },
          {
            props: { size: "medium" },
            style: {
              minWidth: "1.25rem",
              height: "1.25rem",
              padding: "0 6px",
              fontSize: "0.75rem",
            },
          },
        ],
      }),
    },
  },
};
